import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { TbKey } from "react-icons/tb";

import Chip from "components/ds/Chip";
import SectionHeader from "components/ds/SectionHeader";
import type { MFResourceAccessEntity, MFTaskEntityType } from "state/members/tasks";

import { readEntitlementTask } from "./taskMeta";

export interface EntitlementTaskDetailsProps {
  entityType: MFTaskEntityType;
  entity?: MFResourceAccessEntity | null;
}

const EntitlementTaskDetails = ({ entityType, entity }: EntitlementTaskDetailsProps) => {
  const { change, entitlementName, entitlementTypeLabel } = readEntitlementTask(
    entityType,
    entity,
  );
  if (!entitlementName) return null;

  return (
    <Box>
      <SectionHeader>
        {change === "remove" ? "Entitlement to remove" : "Entitlement to give"}
      </SectionHeader>
      <Box borderWidth="1px" borderColor="neutral.200" borderRadius="10px" bg="neutral.25" p="md">
        <Flex align="center" gap="sm">
          <Icon
            as={TbKey}
            boxSize="14px"
            color={change === "remove" ? "error.600" : "success.600"}
            flexShrink={0}
          />
          <Text fontSize="smd" fontWeight={500} color="neutral.950" wordBreak="break-word">
            {entitlementName}
          </Text>
          {entitlementTypeLabel && <Chip tone="azurite">{entitlementTypeLabel}</Chip>}
        </Flex>
      </Box>
    </Box>
  );
};

export default EntitlementTaskDetails;
